<app-form-field>
    <app-label [ngClass]="{'font-weight-normal': Unit.BOOLEAN === baseValueDefinition.unit}" [innerHTML]="baseValueDefinition.label | stripTagsExcept: ['link-tags']" />

    @if (baseValueDefinition.inputType === InputType.DROPDOWN && !displayAsYesNoToggle) {
        <mat-select [formControl]="baseValueControl"
                    placeholder="Bitte wählen..."
                    i18n-placeholder="@@assessment.baseValueInput.form.baseValue.placeholder"
                    appInput
                    required>
            @for (selectableValue of baseValueDefinition.selectableValues; track selectableValue) {
                <mat-option [value]="selectableValue.value">
                    {{selectableValue.label}}
                </mat-option>
            }
        </mat-select>
    }

    @if (baseValueDefinition.inputType === InputType.DROPDOWN && displayAsYesNoToggle) {
        <app-toggle-button [formControl]="baseValueControl"
                           yes="Ja"
                           no="Nein"
                           appInput
                           required />
    }

    @if (Unit.BOOLEAN === baseValueDefinition.unit) {
        <mat-checkbox [formControl]="baseValueControl"
                      color="primary"
                      appInput />
    }

    @if (baseValueDefinition.inputType === InputType.NUMBER_INPUT && Unit.BOOLEAN !== baseValueDefinition.unit) {
        <input [formControl]="baseValueControl"
               [placeholder]="baseValueDefinition.placeholder"
               [suffix]="baseValueDefinition.suffix"
               [mask]="baseValueDefinition.mask"
               appInput
               required>
    }

    @if (baseValueControl.hasError('required')) {
        <app-form-field-error>
            {{ baseValueDefinition.requiredMessage }}
        </app-form-field-error>
    }

    @if (errorMessage) {
        <app-form-field-error>
            {{ errorMessage }}
        </app-form-field-error>
    }

    @if (!!multipleCompanies && baseValueDefinition.inputType === InputType.NUMBER_INPUT) {
        <p i18n="@@assessment.baseValueInput.form.baseValue.numberInput">
            Bitte addieren Sie die Werte aller Betriebe aus Ihrem Familienverbund.
        </p>
    }

    @if (iconAfterInput) {
        <p slot="after-input" class="icon-wrapper">
            <app-icon [name]="iconAfterInput" />
        </p>
    }
</app-form-field>

@if (helpText) {
    <p>{{ helpText }}</p>
}
